import {actions} from '@/store/modules/Profile/actions';
import {getters} from '@/store/modules/Profile/getters';
import {mutations} from '@/store/modules/Profile/mutations';
import {state} from '@/store/modules/Profile/state';

export default {
    actions,
    getters,
    mutations,
    state,
};
